module.exports = __webpack_public_path__ + "img/base.f0d91c76.png";